<template>   
<el-dialog     :visible.sync="dialogVisible"     width="0"     custom-class="public-dialog-class"     :append-to-body="true"     :close-on-click-modal="false"     :close-on-press-escape="false"     :show-close="false"   >     <Add ref="add" @cancel="cancel" @confirm="openResult" />     <Result       :fromBookPreview="fromBookPreview"       ref="result"       @cancel="refresh"       @open="openBook"     />   
</el-dialog> </template>

<script>
import Add from "./add.vue";
import Result from "./result.vue";
/** 加入班级 */
export default {
  components: { Add, Result },
  props: {
    fromBookPreview: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialogVisible: false,
    };
  },
  methods: {
    open() {
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.add.open();
      });
    },
    /** 打开结果 */
    openResult(data) {
      this.$refs.result.open(data);
    },
    /** 打开教材 */
    openBook(row) {
      this.cancel();
      this.$router.push({
        path: `/bookPreview?bookId=${row.bookId}`,
      });
    },
    /** 纯关闭 */
    cancel() {
      this.dialogVisible = false;
    },
    /** 带刷新关闭 */
    refresh() {
      this.cancel();
      this.$emit("refresh");
    },
  },
};
</script>

<style lang="scss" scoped>
:deep(.el-dialog__body) {
  padding: 0;
}
</style>
